import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import jspdf from 'jspdf';
import html2canvas from 'html2canvas';

import { PedidoPdf } from '../models/pedido-pdf';
import { PedidoService } from '../pedido.service';
import { PedidoProdutoPdf } from '../models/pedido-produto-pdf';
import { Parametro } from '../../parametrizacao/models/parametrizacao';
import { ParametrizacaoService } from '../../parametrizacao/parametrizacao.service';

@Component({
  selector: 'app-pedido-pdf',
  templateUrl: './pedido-pdf.component.html',
  styleUrls: ['./pedido-pdf.component.scss']
})
export class PedidoPdfComponent implements OnInit {

  private idPedido: string = "0";
  public itemPedido: PedidoPdf;
  public listaProduto: PedidoProdutoPdf[] = [];
  parametros: Parametro[];
  cols: any[];
  public parcelas: Date[];

  constructor(public pedidoService: PedidoService, private router: Router, private route: ActivatedRoute, private activateRoute: ActivatedRoute,private parametrizacaoService: ParametrizacaoService) { }

  title = 'SIGEVE - Impressão do Pedido';

  ngOnInit(): void {

    this.idPedido = this.route.snapshot.paramMap.get("id");    
    this.itemPedido = this.activateRoute.snapshot.data['PedidoPdf'];
    this.getPedidoListaProduto(this.idPedido);
    this.cols = [
 
      { field: 'nomeProduto', header: 'Produto' },
      { field: 'quantidade', header: 'Quantidade' },
      { field: 'vlUnitario', header: 'Valor Unitário' },
      { field: 'vlTotal', header: 'Valor Total' }
  ];
  this.getParametrosEvento();
  }

  calcularParcelas(){
    this.parcelas=[];
    this.parcelas.push(this.itemPedido.dtPrimeiraParcela)

    for(let i=1;i<this.itemPedido.qtdParcelas;i++){
      
      let data:Date= new Date(this.itemPedido.dtPrimeiraParcela);
      let data2:Date= new Date(this.itemPedido.dtPrimeiraParcela);
      data2.setMonth(data2.getMonth()+i);

     
      if((((data.getMonth()+i)%12)+1)==2 ){
        if(data2.getFullYear()%4!==0){
          if(data.getDate()>28){
            data.setDate(28)
          }
        }else{
          if(data.getDate()>29){
            data.setDate(29)
          }
        }
      }

      if((((data.getMonth()+i)%12)+1)==4 ||(((data.getMonth()+i)%12)+1)==6 || (((data.getMonth()+i)%12)+1)==9 ||(((data.getMonth()+i)%12)+1)==11){
        
          if(data.getDate()>30){
            data.setDate(30)
          }
        
      }
      data.setMonth(data.getMonth()+i);
      this.parcelas.push(data)
    }

  }

  generatePDF() {

    var data = document.getElementById('contentToConvert');
    let pdf = new jspdf('p', 'mm', 'a4',true);
    const TAMANHO_MAX = 2500
    const TAMANHO = 2350

   console.log(data.clientHeight )
    if(data.clientHeight>TAMANHO_MAX){
    html2canvas(data,{width:1799,height:TAMANHO,windowWidth: 1799,  scrollY: 0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')
      if(data.clientHeight <= TAMANHO){
        pdf.save('SIGEVE_Pedido_' + this.idPedido + '.pdf');
    }
      
    }).finally(() =>{

      if(data.clientHeight > TAMANHO)

      html2canvas(data,{width:1799,height:TAMANHO,windowWidth: 1799,  scrollY: -TAMANHO}).then(canvas => {
        var imgWidth = 208;

        var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
        const contentDataURL = canvas.toDataURL('image/png')
        var position = 10;
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')

      pdf.save('SIGEVE_Pedido_' + this.idPedido + '.pdf');
      
    });
    })
  }else{
    html2canvas(data,{width:1799,height:TAMANHO_MAX,windowWidth: 1799,  scrollY: 0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')
      pdf.save('SIGEVE_Pedido_' + this.idPedido + '.pdf');
    
      
    })
  }
    
  
  }

  

  printPDF() {

    var data = document.getElementById('contentToConvert');
    let pdf = new jspdf('p', 'mm', 'a4',true);
    const TAMANHO_MAX = 2500
    const TAMANHO = 2350

   console.log(data.clientHeight )
    if(data.clientHeight>TAMANHO_MAX){
    html2canvas(data,{width:1799,height:TAMANHO,windowWidth: 1799,  scrollY: 0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')
      if(data.clientHeight <= TAMANHO){
      var blob = pdf.output("blob");
      var file = new File([blob], 'SIGEVE_Pedido_' + this.idPedido + '.pdf');
    window.open(URL.createObjectURL(blob), '_blank');
    }
      
    }).finally(() =>{

      if(data.clientHeight > TAMANHO)

      html2canvas(data,{width:1799,height:TAMANHO,windowWidth: 1799,  scrollY: -TAMANHO}).then(canvas => {
        var imgWidth = 208;

        var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
        const contentDataURL = canvas.toDataURL('image/png')
        var position = 10;
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')


      

      /*this.mailService.sendEmail(file).subscribe(
        (res) => {
          if (res) {
           console.log(res)
            
          }
        },
        err => {
          console.log("ERRO PDF-PEDIDO: " + err);
        }
      );*/
      var blob = pdf.output("blob");
      var file = new File([blob], 'SIGEVE_Pedido_' + this.idPedido + '.pdf');
    window.open(URL.createObjectURL(blob), '_blank');
      
    });
    })
  }else{
    html2canvas(data,{width:1799,height:TAMANHO_MAX,windowWidth: 1799,  scrollY: 0}).then(canvas => {
      var imgWidth = 208;
      var imgHeight = 280;//canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight,'','FAST')

      var blob = pdf.output("blob");
      var file = new File([blob], 'SIGEVE_Pedido_' + this.idPedido + '.pdf');
    window.open(URL.createObjectURL(blob), '_blank');

      
    })
  }

    

    
  
  }
  getParametrosEvento() {

    

    this.parametrizacaoService.getParametros().subscribe(
      (res) => {
        if (res) {
          this.parametros = res;  
          console.log(res);     
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Parametros");
        console.log(err);
      }
    );
  } 
  getParametro(nomeParametro: string){
    return this.parametros?.filter(k => k.nome.toLowerCase()==nomeParametro.toLowerCase()).map(m=> m.valor)[0];
  }


  getPedido(idPedido) {

    this.pedidoService.getPedidoPdf(idPedido).subscribe(
      (res) => {
        if (res) {
          this.itemPedido = res;
        }
      },
      err => {
        console.log("ERRO PDF-PEDIDO: " + err);
      }
    );
  }

  getPedidoListaProduto(idPedido) {

    this.pedidoService.getPedidoProdutoPdfLista(idPedido).subscribe(
      (res) => {
        if (res) {
          this.listaProduto = res;
          if(this.itemPedido.flParcelado){
            this.calcularParcelas();
          }
        }
      },
      err => {
        console.log("ERRO PDF-PEDIDO-PRODUTO: " + err);
      }
    );
  }

  BackPedidoClick(idPedido: string) {
    this.router.navigate(['/pedido', idPedido])
  }

}